import { useMemo, useCallback } from 'react';
import { useSearchFilters } from '../../../../common/components/SearchHeader/filters/useSearchFilters';
import { FacetResult } from '../../../../common/schema/hannibal/types.generated';

export const useOptions = (
  facetResults: readonly FacetResult[] | null | undefined,
  exclude: string[] = [],
) =>
  useMemo(
    () =>
      facetResults
        ?.filter(value => !exclude.includes(value.term))
        .map(facetResult => ({
          label: facetResult.term,
          value: facetResult.term,
        })) || [],
    [facetResults, exclude],
  );

export const useClearFilters = () => {
  const [filters, setFilters] = useSearchFilters();

  return useCallback(
    () =>
      setFilters({
        ...filters,
        language: undefined,
        paymentMethod: undefined,
        governmentScheme: undefined,
      }),
    [filters, setFilters],
  );
};

export const useAppliedFilterCount = () => {
  const [filters] = useSearchFilters();

  return useMemo(
    () =>
      [filters.language, filters.paymentMethod, filters.governmentScheme].filter(
        filter => filter !== undefined,
      ).length,
    [filters.language, filters.paymentMethod, filters.governmentScheme],
  );
};
